$('.carousel-main, .collection-carousel').flickity({
    pageDots: false,
    wrapAround: true,
    imagesLoaded: true,
    arrowShape: 'm54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z'
});

$('.slider-icon').flickity({
    pageDots: false,
    wrapAround: true,
    cellAlign: "left",
    arrowShape: 'm54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z'
});

$(document).on('click', '.cart-popup__close', function () {
    $('.custom-cart-popup').css("display", "none");
});

$('body').on('click', '.ad_to_cart', function () {
    var var_id = $(this).attr('var_id');
    var sale_price = $(this).attr('data-sale-price');
    var orignal_price = $(this).attr('data-orignal-price');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: var_id,
            properties: {
                _sale_price: sale_price,
                _original_price: orignal_price
            }
        },
        dataType: 'json',
        success: function (data) {
            console.log(data)
            console.log(data.properties._original_price)
            console.log(data.properties._sale_price)


            $('.custom-cart-popup').css("display", "block");
            $('.custom-cart-popup .cart-popup-item__title').html(data.title);

            if (data.properties.orignal_price) {
                $('.custom-cart-popup .orignal-price').html(data.properties.orignal_price);
                $('.custom-cart-popup .orignal-price').css("margin-right", "10px");
            } else if (data.properties._original_price) {
                $('.custom-cart-popup .orignal-price').html(data.properties._original_price);
                $('.custom-cart-popup .orignal-price').css("margin-right", "10px");
            }
            if (data.properties.sale_price) {
                $('.custom-cart-popup .sale-price').html(data.properties.sale_price);
            } else {
                $('.custom-cart-popup .sale-price').html(data.properties._sale_price);
            }


            $('.custom-cart-popup .cart-popup-item__image').attr('src', data.image);
            $('.custom-cart-popup .cart-popup-item__image').attr('alt', data.title);


            jQuery.getJSON('/cart.js', function (cart) {
                $('.custom-cart-popup .cart-value').html(theme.Currency.formatMoney(cart.items_subtotal_price));
            });

            let current_val = $('#sidebar-CartCount').text();
            let update_val = parseInt(current_val) + 1;
            $('#sidebar-CartCount').text(update_val);

        },
        error: function (data) {

            let preview = `<div class="alert alert-danger alert-dismissible">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>`;
            preview = preview + '<strong>' + data.responseJSON.message + '! </strong>' + data.responseJSON.description + '</div>';

            $('.custom-cart-popup').css("display", "block");

            $('.custom-cart-popup').empty();
            $('.custom-cart-popup').append(preview);
        }
    });
});


$(document).ready(function () {
    $("body").on("click", ".cart__row .cart__qty .quantity-button", function () {

        var $button = $(this);
        var oldValue = $(this).closest('.cart__qty').find('.cart__qty-input').val();

        if ($button.hasClass('item-increment')) {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below one
            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }

        $(this).closest('.cart__qty').find('.cart__qty-input').val(newVal);
        var itemQty = $(this).closest('.cart__qty').find('.cart__qty-input').val();

        if (itemQty == 0) {
            $(this).closest('tr').css("display", "none");
        }
        var item_price = $(this).closest('tr').find('.orignal-price').attr('data-orignal-price');

        $(this).closest('tr').find('span[data-cart-item-regular-price]').text(theme.Currency.formatMoney((item_price * itemQty)));


        $('.quantity-button').css({ "cursor": "not-allowed", "pointer-events": "none" });

        var data_item_key = $(this).closest('.single_product_row').attr('data-cart-variant-id');
        var data = { updates: {} };
        data.updates[data_item_key] = itemQty;
        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function (cart) {
                $('#sidebar-CartCount').html(cart.item_count);
                $('.site-header__cart-count').find('span[data-cart-count]').text(cart.item_count);
                $('.cart-subtotal__price').html(theme.Currency.formatMoney(cart.original_total_price, theme.moneyFormat) + " USD");

                if (cart.original_total_price <= 0) {
                    $('.not-empty-cart').css('display', 'none');
                    $('.empty-cart').attr("style", "display: block !important");
                }

                $('.quantity-button').css({ "cursor": "pointer", "pointer-events": "auto" });
              if (cart) {
                  let subscription = false;
                  cart.items.forEach(element => {
                      if (typeof element.properties.shipping_interval_frequency != "undefined") {
                          subscription = true;
                      }
                  });
                  if	(!subscription) {
                      $('.cart__submit-controls').html('<a href="/checkout" class="cart__submit btn btn--small-wide">Check out</a>');
                  }
              }

            }
        });

    });
});

function instantBuy() {
    window.location.href = "/cart";
}

//Make Recipies blog and page actice in side-nav
if (!$('.site-nav').find(".site-nav__link--active").length) {

    var url = window.location.href;
    $('.site-nav__label').each(function () {

        if (url.includes('/products/')) {
            if ($(this).text() == "Shop") {
                $(this).css('opacity', '1');
            }
        }
        else {
            if ($(this).text() == "Movement" && template.indexOf('movement') != -1) {
                $(this).css('opacity', '1');
            }
            else if ($(this).text() == "Recipes" && template.indexOf('recipe') != -1) {
                $(this).css('opacity', '1');
            }
        }
    })
}

//Product page Why product title and Ingredints Design
var productTitle_height = $(".description > .detail > .product-title").height();
productTitle_height = parseInt(productTitle_height) + 8;
$(".description > .ingredients > .product-ingredients").css("height", + productTitle_height + "px");

$(document).ready(function() {
    if (typeof ReCharge !== 'undefined'
        && ReCharge.products
        && ReCharge.products.length
        && ReCharge.products[0].options
    ) {
        if (ReCharge.products[0].id === 6608661938313
            || ReCharge.products[0].id === 4929067188361
            || ReCharge.products[0].id === 4569860276361
            || ReCharge.products[0].id === 906193076285
            || ReCharge.products[0].id === 906192977981) {
            ReCharge.products[0].options.money_format = '${{amount}}/Bottle';
        } else if (ReCharge.products[0].id === 6582567665801
            || ReCharge.products[0].id === 5116445524105
            || ReCharge.products[0].id === 6776046092425
            || ReCharge.products[0].id === 5271887216777) {
            ReCharge.products[0].options.money_format = '${{amount}}/Bag';
        } else if (ReCharge.products[0].id === 6536074854537) {
            ReCharge.products[0].options.money_format = '${{amount}}/Pack';
        } else if (ReCharge.products[0].id === 6707984564361) {
            ReCharge.products[0].options.money_format = '${{amount}}/Tincture';
        } else {
            ReCharge.products[0].options.money_format = '${{amount}}/Jar';
        }
    }

    $(document).on('click', '#qty__type__onetime .custom-qty-option-price, #qty__type__onetime .custom-qty-option', function (e) {
        var variantId = $('.product-form [name="id"]').val();
        if (typeof ReCharge !== 'undefined'
            && ReCharge.products
            && ReCharge.products.length
            && ReCharge.products[0].variant_to_price
            && ReCharge.products[0].variant_to_price[variantId]
        ) {
            ReCharge.products[0].variant_to_price[variantId] = $(this).data('price-raw');

            // if (ReCharge.products[0].variant_to_duplicate) {
            //     var subscriptionVariant = ReCharge.products[0].variant_to_duplicate[variantId];
            //     if (subscriptionVariant) {
            //         if (ReCharge.products[0].duplicate_to_price
            //             && ReCharge.products[0].duplicate_to_price[subscriptionVariant]
            //         ) {
            //             var rowPrice = Number($(this).data('price-raw'));
            //             ReCharge.products[0].duplicate_to_price[subscriptionVariant]
            //                 = Math.round(rowPrice - rowPrice * ReCharge.products[0].discount_percentage / 100);
            //         }
            //     }
            // }
        }
    });

    // $(document).on('click', '#qty__type__autodeliver .custom-qty-option', function (e) {
    //     var variantId = $('.product-form [name="id"]').val();
    //     if (typeof ReCharge !== 'undefined'
    //         && ReCharge.products
    //         && ReCharge.products.length
    //         && ReCharge.products[0].duplicate_to_price
    //         && ReCharge.products[0].duplicate_to_price[variantId]
    //     ) {
    //         var rowPrice = Number($(this).data('price-raw'));
    //         var onetimeItem = $('#qty__type__onetime .custom-qty-option-price[data-value="' + $(this).data('value') + '"]');
    //         if (onetimeItem.length) {
    //             rowPrice = Number(onetimeItem.data('price-raw'));
    //         }
    //
    //         ReCharge.products[0].duplicate_to_price[variantId]
    //             = Math.round(rowPrice - rowPrice * ReCharge.products[0].discount_percentage / 100);
    //
    //         if (ReCharge.products[0].variant_to_duplicate) {
    //             var onetimeVariant = Object.keys(ReCharge.products[0].variant_to_duplicate)
    //                 .find(function (key) {
    //                     return ReCharge.products[0].variant_to_duplicate[key] === variantId;
    //                 });
    //             if (onetimeVariant) {
    //                 if (ReCharge.products[0].variant_to_price
    //                     && ReCharge.products[0].variant_to_price[onetimeVariant]
    //                 ) {
    //                     ReCharge.products[0].variant_to_price[onetimeVariant] = rowPrice;
    //                 }
    //             }
    //         }
    //     }
    // });
});
